<template>
  <div class="promo-publish-info">
    <span>{{ StatusConstantTitleToObj[status.label]?.title }}</span>
    <v-icon size="14" :color="status.color">md:lens</v-icon>
  </div>
</template>

<script>
import PromoStatusMixin from "@/utils/PromoStatusMixin";
import { StatusConstantTitleToObj } from "@/utils/constants/PromptStatusesConstants";

export default {
  name: "RfPromoPublishStatus",
  mixins: [PromoStatusMixin],
  props: ["item"],
  setup: () => ({ StatusConstantTitleToObj }),
  computed: {
    status() {
      return this.promoStatus(this.item);
    },
  },
};
</script>
